import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchLabDepartmentDD } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const DepartmentFilterDropDown = ({ setFilterValue }) => {
  const key = "lab_department_id";
  const login = useSelector((state) => state.jwtAuthreducer);

  const { data, isLoading, refetch, error } = useQuery(
    ["department-dropdown"],
    () => fetchLabDepartmentDD({ ...login }),
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  useEffect(() => {
    refetch()
  }, [login])
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading franchise type</div>;
  const options =
    data?.data?.data?.map((item) => ({
      value: item.id,
      label: item.department,
    })) || [];

  return (
    <Select
      options={options}
      isClearable
      placeholder={`Select Department`}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      onChange={(selectedOption) => {
        const value = selectedOption ? selectedOption.value : "";
        let franchiseValueone = [];
        franchiseValueone.push(value);
        setFilterValue("lab_department_id", value);
      }}
      className={`react-select-container is-invalid }`}
    ></Select>
  );
};

export default DepartmentFilterDropDown;
